import { parseDate } from "helpers";
import { getLineitemStatus, LineitemStatus } from "model/lineitems";
import { getAllCampaignsObject } from "redux/campaigns/selectors";
import { createSelector } from "reselect";
import { getCampaignsLineitemsStatusServerObject } from "./statusServerSelectors";

export const getLineitemsStatusObjectByCampaignId = createSelector(
  //input selectors
  [
    getCampaignsLineitemsStatusServerObject,
    getAllCampaignsObject,
    (state, campaignId: string) => campaignId,
  ],
  //output selectors
  (campaignListStatusServerObject, allCampaignsObject, campaignId) => {
    const lineItemsStatuses: { [liId: string]: LineitemStatus } = {};

    const campaignStatusServerObject =
      campaignListStatusServerObject[campaignId];
    const lineitemsStatusServerObject = campaignStatusServerObject?.lineitems;
    const campaignLineitems = allCampaignsObject[campaignId]?.lineitems;

    if (lineitemsStatusServerObject) {
      Object.keys(lineitemsStatusServerObject).forEach((lId) => {
        const lineitem = campaignLineitems?.find((l) => l.id === lId);
        const { runState } =
          lineitemsStatusServerObject?.[lId]?.lineitemState || {};
        const status = getLineitemStatus(
          runState,
          parseDate(lineitem?.finish || null)
        );
        lineItemsStatuses[lId] = status;
      });
    }
    return lineItemsStatuses;
  }
);

export const getLineitemsArchivedObjectByCampaignId = createSelector(
  [getCampaignsLineitemsStatusServerObject, (state, campaignId: string) => campaignId],
  (campaignListStatusServerObject, campaignId) => {
    const result: { [liId: string]: boolean } = {};
    const lineitems = campaignListStatusServerObject[campaignId]?.lineitems;
    if (lineitems) {
      Object.keys(lineitems).forEach((lId) => {
        result[lId] = lineitems[lId]?.lineitemState?.archived ?? false;
      });
    }
    return result;
  }
);

type IAllCampaignsLineitemListRunStates = {
  [lineitemId: string]: {
    status: LineitemStatus;
    archived: boolean;
  };
};
export const getAllCampaignsLineitemListRunStates = createSelector(
  getCampaignsLineitemsStatusServerObject,
  getAllCampaignsObject,
  (campaignListStatusObject, allCampaignsObject) => {
    const lineItemsStatuses: IAllCampaignsLineitemListRunStates = {};

    Object.keys(campaignListStatusObject)?.forEach((campaign) => {
      const statusObjLineitems = campaignListStatusObject[campaign]?.lineitems;
      const campaignLineitems = allCampaignsObject[campaign]?.lineitems;
      if (statusObjLineitems) {
        Object.keys(statusObjLineitems).forEach((li) => {
          const lineitem = campaignLineitems?.find((l) => l.id === li);
          const { runState, archived } =
            statusObjLineitems?.[li]?.lineitemState || {};
          const status = getLineitemStatus(
            runState,
            parseDate(lineitem?.finish || null)
          );
          lineItemsStatuses[li] = { status, archived };
        });
      }
    });
    return lineItemsStatuses;
  }
);
